import { Controller } from '@hotwired/stimulus';
import { deleteRequest } from '../src/utils';

import { Calendar, dayGridPlugin, interactionPlugin, rrulePlugin } from '../src/cal.js';

let modal = null;

// Connects to data-controller="calendar"

// Used in: calendar schools partial
// Purpose: Create a js calendar from a schools 'calendar events' (holidays, lessons, no newcomer periods, concerts, notes), these are prepared in schools controller as @events and transmitted as 'events' value - concert and note events tbc.
// Explanation: rrule plugin is used to add recurring events for lessons, ex.: 'monday am'
// Question: is html calendar events value really the right way to get events? Wouldn't get request to api be better?
// Refactor:
// 1. Check if need default for events array
// 2. toggle, save and delete all do the same thing

export default class extends Controller {
  static targets = ['note', 'concert', 'calendarNote', 'noNewcomerPeriod', 'lesson', 'holiday', 'lessonCancellation'];

  static values = {
    date: String, // Used for 'today' button
    events: Array,
    default: [
      {
        id: 1,
        title: 'No events yet',
        editable: false,
        start: this.dateValue,
        end: this.dateValue,
        className: 'bg-red-500',
      },
    ],
  };

  connect() {
    // Create the calendar using the events value
    console.log('calendar controller connected');
    let events = this.eventsValue;
    let modifiedEvents = events.map((event) => {
      if (event.start !== event.end) {
        let newEvent = { ...event };
        let endDate = new Date(newEvent.end);
        endDate.setDate(endDate.getDate() + 1);
        newEvent.end = endDate.toISOString().substring(0, 10);
        return newEvent;
      }
      return event;
    });

    let calendarEl = document.getElementById('calendar');
    let calendar = new Calendar(calendarEl, {
      selectable: true,
      plugins: [dayGridPlugin, rrulePlugin],
      events: modifiedEvents,
      firstDay: 1,
      height: 'auto',
      // stimulus value date;
      initialDate: this.dateValue,
      // editable: true,
      nowIndicator: true,
      displayEventTime: true,
      eventTimeFormat: {
        hour: 'numeric', // numeric hour (e.g., '02' or '12')
        minute: '2-digit', // numeric minute (e.g., '00')
        meridiem: 'short', // short meridiem ('AM' or 'PM')
        hour12: true, // 12-hour time
      },

      // Open the corresponding modal to the event type on click
      eventClick: (info) => {
        console.log('info.event.extendedProps.itemType', info.event.extendedProps.itemType);
        console.log('info.event.extendedProps.link', info.event.extendedProps.link);
        this.idValue = info.event.id;
        const { itemType, link } = info.event.extendedProps;
        this.itemTypeValue = itemType;
        console.log('itemtype', itemType);
        const targetEl = {
          note: this.noteTarget,
          concert: this.concertTarget,
          calendar_note: this.calendarNoteTarget,
          no_newcommer_period: this.noNewcomerPeriodTarget,
          lesson: this.lessonTarget,
          holiday: this.holidayTarget,
          lesson_cancellation: this.lessonCancellationTarget
        }[itemType];
        if (link) {
          this.holidayTarget.dataset.link = link;
          console.log('this.holidayTarget.dataset', this.holidayTarget.dataset);
        }
        modal = new Modal(targetEl);
        modal.show();
      },
    });

    calendar.render();
  }

  redirect(event) {
    // Redirect holiday events to the show page (from target dataset) on click
    console.log('redirect');
    console.log('event', event);
    console.log('event.currentTarget.dataset', event.currentTarget.dataset);

    let { link } = this.holidayTarget.dataset;
    console.log({ link });
    window.location.href = link;
  }
  toggle() {
    console.log('toggle modal');
    modal.toggle();
  }
  save() {
    console.log('save item');
    modal.toggle();
  }
  async delete() {
    console.log('delete item');
    console.log(this.idValue);
    try {
      if (this.itemTypeValue == 'concert') {
        console.log('delete concert');
        await deleteRequest(`/admin/concerts/${this.idValue}`);
      } else if (this.itemTypeValue == 'calendar_note') {
        console.log('delete calendar note');
        await deleteRequest(`/admin/calendar_notes/${this.idValue}`);
      } else if (this.itemTypeValue == 'no_newcommer_period') {
        console.log('delete no newcommer period');
        await deleteRequest(`/admin/no_newcommer_periods/${this.idValue}`);
      } else if (this.itemTypeValue == 'lesson_cancellation') {
        console.log('delete lesson cancellation');
        await deleteRequest(`/admin/lesson_cancellations/${this.idValue}`);
      }
      // modal.toggle();
      // fix this to not use reload but to remove the event from the calendar
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  }
}
